import { useField } from 'formik';
import { FormLabel, FormControl, FormHelperText } from '@mui/material';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';

import { controlError } from 'utils';

export interface DatePickerFieldProps extends Omit<
  DatePickerProps,
  'label' | 'value' | 'onChange'
> {
  name: string;
  label: string;
  format?: string;
  required?: boolean;
  hideFormatText?: boolean;
}

export const DatePickerField = ({
  name,
  label,
  required,
  className,
  hideFormatText,
  format = 'MM/DD/YYYY',
  ...props
}: DatePickerFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);
  const hasError = Boolean(errorText);

  return (
    <FormControl error={hasError} className={className}>
      {label && (
        <FormLabel className="text-black-primary mb-1">
          {label}
          {required && <span className="text-red-primary-primary">*</span>}
        </FormLabel>
      )}
      <DatePicker
        onChange={(value) => helpers.setValue(value)}
        value={field.value === '' ? null : field.value}
        {...props}
        slotProps={{
          textField: {
            helperText: !hideFormatText && format,
          },
        }}
      />
      {hasError && (
        <FormHelperText className="!ml-0">{errorText}</FormHelperText>
      )}
    </FormControl>
  );
};
